<template>
  <div class="was-garden-container">
    <div class="page-header">
      <div class="breadcrumb">ຂໍ້ມູນໂຮງຮຽນ / <span>ນ້ຳ-ສວນ-ອາຫານທ່ຽງ</span></div>
      <div class="header-content">
        <h1>ນ້ຳ, ສຸຂະອະນາໄມ, ສວນຄົວ ແລະ ອາຫານທ່ຽງ</h1>
        <p>ບັນທຶກຂໍ້ມູນພື້ນຖານດ້ານສຸຂະອະນາໄມ ແລະ ການບໍລິການອາຫານໃນໂຮງຮຽນ</p>
      </div>
    </div>  

    <div v-if="loading" class="loading-state-full">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
      <p>ກຳລັງໂຫຼດຂໍ້ມູນ...</p>
    </div>

    <form v-else @submit.prevent="handleSubmit">
      <!-- ຂໍ້ມູນໂຮງຮຽນ Header -->
      <div class="info-card mb-4">
        <div class="section-label"><i class="fas fa-school"></i> ຂໍ້ມູນລະບຸໂຮງຮຽນ</div>
        <div class="field-row-4">
          <div class="form-group">
            <label class="req">1. ສົກຮຽນ</label>
            <input type="text" v-model="form.academic_year" placeholder="ຕົວຢ່າງ: 2024-2025"
                   pattern="\d{4}-\d{4}" title="ຮູບແບບ: YYYY-YYYY" maxlength="9">
          </div>
          <div class="form-group">
            <label>2. ລະຫັດໂຮງຮຽນ</label>
            <input type="text" :value="schoolInfo.school_id || user.school_id || user.school_code" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>3. ຊື່ແຂວງ</label>
            <input type="text" :value="schoolInfo.prov_name || user.prov_name || user.province_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>4. ຊື່ເມືອງ</label>
            <input type="text" :value="schoolInfo.district_name_lao || user.district_name_lao || user.district_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
        </div>
        <div class="field-row-3">
          <div class="form-group">
            <label>5. ຊື່ຕາແສງ</label>
            <input type="text" :value="schoolInfo.commune_name || ''" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>6. ຊື່ບ້ານທີ່ໂຮງຮຽນຕັ້ງຢູ່</label>
            <input type="text" :value="schoolInfo.school_village || ''" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
          <div class="form-group">
            <label>7. ຊື່ໂຮງຮຽນ</label>
            <input type="text" :value="schoolInfo.school_name_lao || user.school_name" disabled class="auto-field">
            <span class="auto-badge">AUTO</span>
          </div>
        </div>
      </div>

      <div class="tabs-container shadow-sm">
        <div class="tabs-nav">
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'wash' }" @click="activeTab = 'wash'">
            <i class="fas fa-faucet"></i> ນ້ຳ ແລະ ສຸຂະອະນາໄມ (WASH)
          </button>
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'garden' }" @click="activeTab = 'garden'">
            <i class="fas fa-seedling"></i> ສວນຄົວໂຮງຮຽນ
          </button>
          <button type="button" class="tab-btn" :class="{ active: activeTab === 'lunch' }" @click="activeTab = 'lunch'">
            <i class="fas fa-utensils"></i> ອາຫານທ່ຽງ
          </button>
        </div>

        <div class="tab-content pt-4">
          <!-- Tab 1: WASH -->
          <div v-if="activeTab === 'wash'" class="tab-pane">

            <!-- Q8 + Q9: ນ້ຳໃຊ້ ແລະ ນ້ຳດື່ມ -->
            <div class="panel-section mb-4">
              <h4><i class="fas fa-water"></i> ນ້ຳໃຊ້ ແລະ ນ້ຳດື່ມ</h4>

              <!-- Q8 -->
              <div class="form-group">
                <label>8. ໂຮງຮຽນແຫ່ງນີ້ ມີນ້ຳໃຊ້ໃນໂຮງຮຽນບໍ່?</label>
                <select v-model="form.has_water">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <template v-if="form.has_water == 1">
                <div class="form-group sub-question">
                  <label>8.1 ແມ່ນນ້ຳປະເພດໃດ? ໃຫ້ເລືອກປະເພດທີ່ໃຊ້ເປັນປະຈຳໃນປັດຈຸບັນ</label>
                  <select v-model="form.water_type">
                    <option value="">-- ເລືອກ --</option>
                    <option value="1">ນ້ຳປະປາ</option>
                    <option value="2">ບາດານ</option>
                    <option value="3">ນ້ຳສ້າງ</option>
                    <option value="4">ນ້ຳລິນ</option>
                    <option value="5">ນ້ຳໜ້າດິນ (ໜອງ, ແມ່ນ້ຳ, ຫ້ວຍ)</option>
                    <option value="6">ອ່າງເກັບນ້ຳຝົນ</option>
                  </select>
                </div>

                <div class="form-group sub-question">
                  <label>8.2 ລະບົບນ້ຳທີ່ມີ ໃຊ້ໄດ້ສະດວກປານໃດ?</label>
                  <select v-model="form.water_usage">
                    <option value="">-- ເລືອກ --</option>
                    <option value="1">ໃຊ້ໄດ້ຕະຫຼອດປີ</option>
                    <option value="2">ໃຊ້ໄດ້ສະເພາະໜ້າຝົນ</option>
                    <option value="3">ໃຊ້ໄດ້ສະເພາະບາງເດືອນ</option>
                    <option value="4">ໃຊ້ໄດ້ ແຕ່ນ້ຳມີປະລິມານໜ້ອຍ ບໍ່ພຽງພໍກັບຄວາມຕ້ອງການ</option>
                    <option value="5">ອື່ນໆ</option>
                  </select>
                </div>
              </template>

              <!-- Q9 -->
              <div class="form-group mt-3">
                <label>9. ໂຮງຮຽນແຫ່ງນີ້ ມີນ້ຳດື່ມໃນໂຮງຮຽນບໍ່?</label>
                <select v-model="form.has_drinking_water">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <div v-if="form.has_drinking_water == 1" class="form-group sub-question">
                <label>9.1 ແຫຼ່ງນ້ຳດື່ມ ໄດ້ມາແຕ່ໃສ?</label>
                <select v-model="form.drinking_water_source">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ນ້ຳປະປາ</option>
                  <option value="2">ນ້ຳສ້າງ/ນ້ຳລິນທີ່ມີການປ້ອງກັນ</option>
                  <option value="3">ນ້ຳບາດານ</option>
                  <option value="4">ນ້ຳຝົນ</option>
                  <option value="5">ນ້ຳສ້າງ/ນ້ຳລິນທີ່ບໍ່ມີການປ້ອງກັນ</option>
                  <option value="6">ນ້ຳບັນຈຸໃນຂວດ (ນ້ຳອະນາໄມ)</option>
                  <option value="7">ລົດແກ່ນ້ຳ ຫຼື ລໍ້</option>
                  <option value="8">ນ້ຳໜ້າດິນ (ໜອງ, ແມ່ນ້ຳ, ຫ້ວຍ)</option>
                  <option value="9">ນັກຮຽນເອົາມາເອງ</option>
                  <option value="10">ນ້ຳຜ່ານອຸປະກອນເຄື່ອງກອງນ້ຳ</option>
                </select>
              </div>
            </div>

            <!-- Q10: ວິດຖ່າຍ -->
            <div class="panel-section mb-4">
              <h4><i class="fas fa-toilet"></i> ວິດຖ່າຍ</h4>

              <div class="form-group">
                <label>10. ໂຮງຮຽນແຫ່ງນີ້ ມີວິດຖ່າຍໃນໂຮງຮຽນບໍ່?</label>
                <select v-model="form.has_toilets">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <template v-if="form.has_toilets == 1">
                <div class="form-group sub-question">
                  <label>10.1 ແມ່ນວິດຖ່າຍປະເພດໃດ?</label>
                  <select v-model="form.toilet_type">
                    <option value="">-- ເລືອກ --</option>
                    <option value="1">ວິດທີ່ໃຊ້ນ້ຳລ້າງ/ຖອກນ້ຳລ້າງ</option>
                    <option value="2">ວິດແຫ້ງທີ່ມີຝາປິດ</option>
                    <option value="3">ວິດແຫ້ງທີ່ບໍ່ມີຝາປິດ</option>
                    <option value="4">ວິດປະເພດອື່ນໆ</option>
                  </select>
                </div>

                <div class="table-wrap sub-question mb-3">
                  <p class="sub-label">10.2 – 10.9 ຈຳນວນວິດຖ່າຍ (ຫົວ)</p>
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>ກຸ່ມຜູ້ໃຊ້</th>
                        <th class="text-center">ໃຊ້ການໄດ້</th>
                        <th class="text-center">ໃຊ້ການບໍ່ໄດ້</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>ຄູສອນ</td>
                        <td><input type="number" min="0" v-model.number="form.t_toilet_ok" class="text-center"></td>
                        <td><input type="number" min="0" v-model.number="form.t_toilet_no" class="text-center"></td>
                      </tr>
                      <tr>
                        <td>ນັກຮຽນຍິງ</td>
                        <td><input type="number" min="0" v-model.number="form.f_student_toilet_ok" class="text-center"></td>
                        <td><input type="number" min="0" v-model.number="form.f_student_toilet_no" class="text-center"></td>
                      </tr>
                      <tr>
                        <td>ນັກຮຽນຊາຍ</td>
                        <td><input type="number" min="0" v-model.number="form.m_student_toilet_ok" class="text-center"></td>
                        <td><input type="number" min="0" v-model.number="form.m_student_toilet_no" class="text-center"></td>
                      </tr>
                      <tr>
                        <td>ໃຊ້ລວມ (Unisex)</td>
                        <td><input type="number" min="0" v-model.number="form.all_toilet_ok" class="text-center"></td>
                        <td><input type="number" min="0" v-model.number="form.all_toilet_no" class="text-center"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="form-group sub-question">
                  <label>10.10 ມີວິດຖ່າຍ ຜູ້ທີ່ມີຂໍ້ຈຳກັດດ້ານການເຄື່ອນໄຫວ ແລະ ທາງສາຍຕາ ສາມາດເຂົ້າເຖິງໄດ້ບໍ່?</label>
                  <select v-model="form.accessible_toilet">
                    <option value="">-- ເລືອກ --</option>
                    <option value="1">ມີ</option>
                    <option value="2">ບໍ່ມີ</option>
                  </select>
                </div>
              </template>
            </div>

            <!-- Q11-13: ການລ້າງມື, ສະບູ, ຫ້ອງອາບນ້ຳ -->
            <div class="panel-section mb-4">
              <h4><i class="fas fa-hand-sparkles"></i> ການລ້າງມື ແລະ ຫ້ອງອາບນ້ຳ</h4>

              <!-- Q11 -->
              <div class="form-group">
                <label>11. ໂຮງຮຽນແຫ່ງນີ້ ມີສິ່ງອຳນວຍຄວາມສະດວກ ສຳລັບການລ້າງມູ ຢູ່ໂຮງຮຽນບໍ່?</label>
                <select v-model="form.has_handwashing">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <div v-if="form.has_handwashing == 1" class="form-group sub-question">
                <label>11.1 ແມ່ນສິ່ງອຳນວຍຄວາມສະດວກປະເພດໃດ?</label>
                <select v-model="form.handwashing_type">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ສ່ວນບຸກຄົນ (ກ໋ອກນ້ຳສຳລັບລ້າງມື)</option>
                  <option value="2">ເປັນກຸ່ມ (ຮາງລ້າງມື)</option>
                  <option value="3">ສ່ວນບຸກຄົນ ແລະ ເປັນກຸ່ມ</option>
                </select>
              </div>

              <!-- Q12 -->
              <div class="form-group mt-3">
                <label>12. ມີສະບູ ສຳລັບລ້າງມືບໍ່?</label>
                <select v-model="form.has_soap">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <div v-if="form.has_soap == 1" class="form-group sub-question">
                <label>12.1 ມີຫຍັງແດ່ໃນການປະຕິບັດຕົວຈິງ?</label>
                <select v-model="form.soap_water_availability">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີນ້ຳ ແລະ ສະບູ</option>
                  <option value="2">ມີນ້ຳ ແຕ່ບໍ່ມີສະບູ</option>
                  <option value="3">ບໍ່ມີນ້ຳ</option>
                </select>
              </div>

              <!-- Q13 -->
              <div class="form-group mt-3">
                <label>13. ໂຮງຮຽນແຫ່ງນີ້ ມີຫ້ອງອາບນ້ຳໃຫ້ເດັກບໍ່?</label>
                <select v-model="form.has_bathroom">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <div v-if="form.has_bathroom == 1" class="form-group sub-question">
                <label>13.1 ມີຫຍັງແດ່ໃນການປະຕິບັດຕົວຈິງ?</label>
                <select v-model="form.bathroom_availability">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີນ້ຳ ແລະ ສະບູ</option>
                  <option value="2">ມີນ້ຳ ແຕ່ບໍ່ມີສະບູ</option>
                  <option value="3">ບໍ່ມີນ້ຳ</option>
                </select>
              </div>

              <!-- Q14 -->
              <div class="form-group mt-3">
                <label>14. ສະຖານທີ່ເປັນສ່ວນຕົວໃຫ້ເດັກຍິງສາມາດລ້າງ ຫຼື ປ່ຽນຜ້າອະນາໄມ</label>
                <select v-model="form.has_menstrual_space">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <div v-if="form.has_menstrual_space == 1" class="form-group sub-question">
                <label>14.1 ມີຫຍັງແດ່ໃນການປະຕິບັດຕົວຈິງ?</label>
                <select v-model="form.menstrual_space_availability">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີນໍ້າ ແລະ ສະບູ</option>
                  <option value="2">ມີນໍ້າ ແຕ່ ບໍ່ມີສະບູ</option>
                  <option value="3">ບໍ່ມີນໍ້າ</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Tab 2: Garden -->
          <div v-if="activeTab === 'garden'" class="tab-pane">
            <div class="panel-section">
              <h4><i class="fas fa-seedling"></i> ສວນຄົວໂຮງຮຽນ</h4>

              <!-- Q15 -->
              <div class="form-group">
                <label>15. ໂຮງຮຽນແຫ່ງນີ້ ມີສວນຄົວໂຮງຮຽນບໍ່?</label>
                <select v-model="form.has_garden">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <template v-if="form.has_garden == 1">
                <div class="form-group sub-question">
                  <label>15.1 ສາມາດເກັບກ່ຽວໄດ້ຕະຫຼອດພາກຮຽນບໍ່?</label>
                  <select v-model="form.garden_harvest_all">
                    <option value="">-- ເລືອກ --</option>
                    <option value="1">ໄດ້</option>
                    <option value="2">ບໍ່ໄດ້</option>
                  </select>
                </div>

                <div class="form-group sub-question">
                  <label>15.2 ໄດ້ໃຊ້ຜັກຈາກສວນຄົວ ເພື່ອເຮັດຫຍັງ? <span class="hint">(ເລືອກໄດ້ຫຼາຍຄຳຕອບ)</span></label>
                  <div class="checkbox-group">
                    <label class="checkbox-item" v-for="opt in gardenUseOptions" :key="opt.value">
                      <input type="checkbox" :value="opt.value" v-model="form.garden_use">
                      <span>{{ opt.label }}</span>
                    </label>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- Tab 3: Lunch -->
          <div v-if="activeTab === 'lunch'" class="tab-pane">
            <div class="panel-section">
              <h4><i class="fas fa-utensils"></i> ອາຫານທ່ຽງ</h4>

              <!-- Q16 -->
              <div class="form-group">
                <label>16. ໂຮງຮຽນແຫ່ງນີ້ ມີການບໍລິການອາຫານທ່ຽງບໍ່?</label>
                <select v-model="form.has_lunch">
                  <option value="">-- ເລືອກ --</option>
                  <option value="1">ມີ</option>
                  <option value="2">ບໍ່ມີ</option>
                </select>
              </div>

              <template v-if="form.has_lunch == 1">
                <div class="form-group sub-question">
                  <label>16.1 ອາຫານທ່ຽງທີ່ໄດ້ຮັບງົບຈາກແຫຼ່ງທຶນໃດ?</label>
                  <select v-model="form.lunch_funding">
                    <option value="">-- ເລືອກ --</option>
                    <option value="1">ລັດຖະບານ</option>
                    <option value="2">ອົງການ/ນິຕິບຸກຄົນຊ່ວຍເຫຼືອ</option>
                    <option value="3">ຊຸມຊົນ/ໂຮງຮຽນ ຈັດຕັ້ງປະຕິບັດເອງ</option>
                    <option value="4">ອື່ນໆ</option>
                  </select>
                </div>

                <div class="form-group sub-question">
                  <label>16.2 ໄດ້ເລີ່ມຈັດຕັ້ງປະຕິບັດວຽກອາຫານທ່ຽງ ແຕ່ປີໃດ?</label>
                  <input type="text" v-model="form.lunch_start_year" placeholder="2020" maxlength="4">
                </div>

                <div class="field-row sub-question">
                  <div class="form-group">
                    <label>
                      16.3 ຈຳນວນວັນທີ່ບໍລິການ ພາກຮຽນ 1
                      <span class="hint">(ບໍ່ເກີນ 150 ວັນ)</span>
                    </label>
                    <input type="number" min="0" max="150" v-model.number="form.lunch_days_s1">
                  </div>
                  <div class="form-group">
                    <label>
                      16.4 ຈຳນວນວັນທີ່ບໍລິການ ພາກຮຽນ 2
                      <span class="hint">(ບໍ່ເກີນ 150 ວັນ)</span>
                    </label>
                    <input type="number" min="0" max="150" v-model.number="form.lunch_days_s2">
                  </div>
                </div>

                <div class="field-row sub-question">
                  <div class="form-group">
                    <label>16.5 ການປະກອບສ່ວນຈາກຊຸມຊົນ ແລະ ແຫຼ່ງທຶນອື່ນໆ ພາກຮຽນ 1 (ກີບ)</label>
                    <input type="number" min="0" v-model.number="form.lunch_money_s1">
                  </div>
                  <div class="form-group">
                    <label>16.6 ການປະກອບສ່ວນຈາກຊຸມຊົນ ແລະ ແຫຼ່ງທຶນອື່ນໆ ພາກຮຽນ 2 (ກີບ)</label>
                    <input type="number" min="0" v-model.number="form.lunch_money_s2">
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions-wrapper mt-4">
        <button type="submit" class="btn-save" :disabled="submitting">
          <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
          {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກຂໍ້ມູນທັງໝົດ' }}
        </button>
      </div>
    </form>

    <!-- Result Modal -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-primary" :class="resultModal.type" @click="resultModal.show = false">ເຂົ້າໃຈແລ້ວ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';

export default {
  name: 'SchoolWasGardenPage',
  data() {
    return {
      loading: false,
      submitting: false,
      activeTab: 'wash',
      isNew: true,
      user: {},
      schoolInfo: { school_id: '', prov_name: '', district_name_lao: '', school_name_lao: '', commune_name: '', school_village: '' },
      gardenUseOptions: [
        { value: '1', label: 'ປຸ່ງແຕ່ງເປັນອາຫານໃນໂຮງຮຽນ' },
        { value: '2', label: 'ເປັນບ່ອນຮຽນຮູ້ສຳລັບນັກຮຽນ' },
        { value: '3', label: 'ຂາຍເພື່ອສ້າງລາຍຮັບເຂົ້າໂຮງຮຽນ' },
        { value: '4', label: 'ແຈກຢາຍໃຫ້ນັກຮຽນ ເອົາກັບບ້ານ' },
        { value: '5', label: 'ອື່ນໆ' },
      ],
      form: {
        academic_year: '',
        school_id: '',
        commune_name: '',
        village_name: '',
        // Q8
        has_water: '', water_type: '', water_usage: '',
        // Q9
        has_drinking_water: '', drinking_water_source: '',
        // Q10
        has_toilets: '', toilet_type: '',
        t_toilet_ok: 0, t_toilet_no: 0,
        f_student_toilet_ok: 0, f_student_toilet_no: 0,
        m_student_toilet_ok: 0, m_student_toilet_no: 0,
        all_toilet_ok: 0, all_toilet_no: 0,
        accessible_toilet: '',
        // Q11
        has_handwashing: '', handwashing_type: '',
        // Q12
        has_soap: '', soap_water_availability: '',
        // Q13
        has_bathroom: '', bathroom_availability: '',
        // Q14
        has_menstrual_space: '', menstrual_space_availability: '',
        // Q15
        has_garden: '', garden_harvest_all: '', garden_use: [],
        // Q16
        has_lunch: '', lunch_funding: '', lunch_start_year: '',
        lunch_days_s1: null, lunch_days_s2: null,
        lunch_money_s1: null, lunch_money_s2: null,
      },
      resultModal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem('user-info') || '{}');
    await Promise.all([this.fetchSchoolInfo(), this.fetchData()]);
  },
  methods: {
    async fetchSchoolInfo() {
      if (!this.user.school_id) return;
      try {
        const res = await api.get(`/getAll/schools/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const s = res.data.rows[0];
          this.schoolInfo = {
            school_id: s.school_id || this.user.school_id,
            prov_name: s.prov_name || '',
            district_name_lao: s.district_name_lao || '',
            school_name_lao: s.school_name_lao || '',
            commune_name: s.commune_name || '',
            school_village: s.school_village || '',
          };
        }
      } catch (e) { console.error(e); }
    },
    async fetchData() {
      if (!this.user.school_id) return;
      this.loading = true;
      try {
        const res = await api.get(`/getAll/school_wash_garden/school_id/${this.user.school_id}`);
        if (res.data.code === 1 && res.data.rows.length > 0) {
          const row = res.data.rows[0];
          // Normalize garden_use: must always be an array for checkbox v-model
          if (!Array.isArray(row.garden_use)) {
            if (typeof row.garden_use === 'string' && row.garden_use.trim()) {
              try { row.garden_use = JSON.parse(row.garden_use); } catch { row.garden_use = []; }
            } else {
              row.garden_use = [];
            }
          }
          // Migrate old field names
          if (!row.water_usage && row.water_convenience) row.water_usage = row.water_convenience;
          if (!row.has_bathroom && row.bathroom_detail) {
            row.has_bathroom = ''; row.bathroom_availability = '';
          }
          this.form = { ...this.form, ...row };
          // Final safety guard — ensure garden_use is always an array after spread
          if (!Array.isArray(this.form.garden_use)) this.form.garden_use = [];
          this.isNew = false;
        } else {
          this.form.school_id = this.user.school_id;
          this.isNew = true;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        const payload = {
          ...this.form,
          garden_use: JSON.stringify(this.form.garden_use),
        };
        let res;
        if (this.isNew) {
          res = await api.post('/insertOne', { table: 'school_wash_garden', items: payload });
        } else {
          res = await api.put(`/update/school_wash_garden/${this.form._id}`, { items: payload });
        }
        if (res.data.code === 1) {
          this.showResult('success', 'ສຳເລັດແລ້ວ', 'ບັນທຶກຂໍ້ມູນຮຽບຮ້ອຍແລ້ວ');
          await this.fetchData();
        }
      } catch (e) {
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດບັນທຶກຂໍ້ມູນໄດ້');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.was-garden-container { animation: fadeIn 0.4s ease; max-width: 1100px; margin: 0 auto; }

/* School Identity Card */
.info-card {
  background: white; border-radius: 16px; padding: 24px 28px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07); border-left: 4px solid var(--lao, #003f8a);
}
.section-label {
  font-size: 13px; font-weight: 700; color: var(--lao, #003f8a);
  margin-bottom: 16px; display: flex; align-items: center; gap: 8px;
}
.field-row-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 16px; }
.field-row-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.auto-field { background: #f1f5f9 !important; color: #64748b; cursor: not-allowed; }
.auto-badge {
  display: inline-block; font-size: 10px; font-weight: 700;
  background: #e0f2fe; color: #0284c7; border-radius: 4px;
  padding: 1px 6px; margin-top: 4px;
}
.req::after { content: ' *'; color: #ef4444; }

/* Header panel */
.panel-section {
  background: white;
  border-radius: 16px;
  padding: 24px 28px;
  border: 1px solid var(--border, #e2e8f0);
}
.panel-section h4 {
  font-size: 15px; color: var(--lao, #003f8a);
  margin-bottom: 20px; padding-bottom: 10px;
  border-bottom: 1px solid var(--border, #e2e8f0);
  display: flex; align-items: center; gap: 8px;
}

/* Tabs */
.tabs-container { background: white; border-radius: 16px; overflow: hidden; }
.tabs-nav { display: flex; background: #f1f5f9; padding: 10px 15px 0; gap: 5px; overflow-x: auto; }
.tab-btn {
  padding: 12px 20px; border: none; background: none; cursor: pointer;
  font-weight: 600; font-size: 13px; color: #64748b; border-radius: 10px 10px 0 0;
  transition: 0.2s; display: flex; align-items: center; gap: 8px; white-space: nowrap;
}
.tab-btn.active { background: white; color: var(--lao, #003f8a); box-shadow: 0 -4px 10px -4px rgba(0,0,0,0.05); }
.tab-content { padding: 30px; }
.tab-pane .panel-section { border: none; padding: 0; }

/* Form fields */
.field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 15px; }
.form-group { margin-bottom: 16px; }
.form-group label { display: block; font-size: 13px; color: var(--text2, #475569); margin-bottom: 8px; font-weight: 600; }
.form-group input,
.form-group select { width: 100%; padding: 10px 12px; border: 1px solid var(--border, #e2e8f0); border-radius: 8px; font-size: 14px; background: white; }
.form-group select { cursor: pointer; }
.form-group input:focus,
.form-group select:focus { outline: none; border-color: var(--lao, #003f8a); box-shadow: 0 0 0 3px rgba(0,63,138,0.08); }

/* Auto-populated readonly field */
.readonly-field { background: #f8fafc !important; color: #94a3b8; cursor: default; }

/* Sub-question indentation */
.sub-question { margin-left: 24px; padding-left: 16px; border-left: 3px solid #e2e8f0; }
.sub-label { font-size: 13px; font-weight: 600; color: var(--text2, #475569); margin-bottom: 10px; }

/* Helpers */
.required { color: #ef4444; }
.hint { font-weight: 400; color: #94a3b8; font-size: 12px; }
.mt-3 { margin-top: 20px; }

/* Toilet table */
.table-wrap { overflow-x: auto; }
.data-table { width: 100%; border-collapse: collapse; background: #f8fafc; border-radius: 10px; overflow: hidden; }
.data-table th { background: #e2e8f0; padding: 12px; font-size: 12px; color: var(--text1, #1e293b); text-align: left; }
.data-table td { padding: 8px 12px; border-bottom: 1px solid #edf2f7; }
.data-table input { background: white; border: 1px solid #cbd5e1; border-radius: 6px; width: 80px; padding: 5px 8px; text-align: center; }
.text-center { text-align: center; }

/* Multi-checkbox for garden use */
.checkbox-group { display: flex; flex-direction: column; gap: 10px; }
.checkbox-item { display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 14px; color: var(--text1, #1e293b); }
.checkbox-item input[type="checkbox"] { width: 17px; height: 17px; cursor: pointer; accent-color: var(--lao, #003f8a); }

/* Save button */
.form-actions-wrapper { display: flex; justify-content: center; }
.btn-save { background: var(--lao, #003f8a); color: white; padding: 15px 50px; border-radius: 12px; font-weight: 700; border: none; cursor: pointer; transition: 0.3s; width: 100%; font-size: 16px; margin-top: 20px; }
.btn-save:hover:not(:disabled) { background: #002d62; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.3); }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }

/* Loading */
.loading-state-full { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 100px 0; color: var(--text3, #94a3b8); }

/* Modal */
.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 9999; }
.custom-modal-card { background: white; width: 100%; max-width: 450px; border-radius: 16px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); overflow: hidden; animation: modalPop 0.3s ease; }
.result-modal { text-align: center; padding: 40px 30px; }
.modal-icon { font-size: 60px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error { color: #ef4444; }
.modal-content-area h2 { font-size: 20px; margin-bottom: 8px; }
.modal-footer-actions { margin-top: 24px; }
.btn-modal-primary { padding: 12px 30px; border: none; border-radius: 8px; cursor: pointer; font-weight: 600; background: var(--lao, #003f8a); color: white; }

@keyframes modalPop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

@media (max-width: 900px) {
  .field-row-4 { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 768px) {
  .field-row, .field-row-3, .field-row-4 { grid-template-columns: 1fr; }
  .tab-content { padding: 15px; }
  .sub-question { margin-left: 12px; padding-left: 10px; }
}
</style>
